import { render, staticRenderFns } from "./search.vue?vue&type=template&id=0a59d432"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/vercel/path0/components/navbar.vue').default,UiButton: require('/vercel/path0/components/ui/button.vue').default,UiIconClose: require('/vercel/path0/components/ui/icon/close.vue').default,FilterColumn: require('/vercel/path0/components/filter/filter-column.vue').default,UiSelect: require('/vercel/path0/components/ui/select.vue').default,UiReadMore: require('/vercel/path0/components/ui/read-more.vue').default,UiChefLoadingCard: require('/vercel/path0/components/ui/chef-loading-card.vue').default,UiLink: require('/vercel/path0/components/ui/link.vue').default,UiPagination: require('/vercel/path0/components/ui/pagination.vue').default,UiContactCard: require('/vercel/path0/components/ui/contact-card.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
